import { Button, FormatText, GridView, MasterDetailForm, Widget } from '@digital/ui';
import React, { useState, useEffect, useMemo } from 'react';
import { Collapse, Icon, version } from 'antd';
import { getFechamentoExecutiveSummaryByFechamentoId } from '@app/api/fechamento';
import { ReportCapexManeger } from '@app/api/relatorios';
const { Panel } = Collapse;
import CapexManagementSumary from '@app/views/Graficos/capexManagementSumary';
import CapexManagement from '@app/views/Graficos/capexManagement';
import CapexManagementGrafico from '@app/views/Graficos/capexManagementGrafico';

interface FechamentoExecutiveSummaryProps {
  fechamentoId: string;
}

const FechamentoExecutiveSummary = (props: FechamentoExecutiveSummaryProps) => {
  const { fechamentoId } = props;
  const [relatorio, setRelatorio] = useState<ReportCapexManeger>();

  useEffect(() => {
    if (fechamentoId) {
      getFechamentoExecutiveSummaryByFechamentoId(fechamentoId).then(data => {
        if (data) setRelatorio(data);
      });
    }
  }, [fechamentoId]);

  return (
    <>
      {relatorio ? (
        <>
          <CapexManagementSumary data={relatorio} />
          <CapexManagementGrafico data={relatorio} />
          <CapexManagement data={relatorio} />
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default FechamentoExecutiveSummary;
